














import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  inheritAttrs: true
})
export default class Checkbox extends Vue {
  @Prop() private readonly color!: string;
  @Prop() private readonly label!: string;
  @Prop({default: true}) private required?: any;
  @Prop({default: false}) private value?: any;
  @Prop({default: false}) private readonly error?: boolean;
  @Prop({default: 1}) private readonly errorCount?: number | string;
  @Prop() private readonly errorMessages?: [];
  @Prop() private readonly name?: string;
  @Prop() private readonly id?: string;

  private data = this.value;

  input(value: any) {
    this.$emit('input', value);
  }

  get listeners() {
    return { ...this.$listeners, change: this.input };
  }
}
